export const extractFileName = (url) => {

  if (typeof url !== "string") return "";

  const fileName = url.split("/").pop().split("?")[0];
  return decodeURIComponent(fileName);
};
